/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type TotalSupplySeriesResponse = {
  data: Array<Array<number>>;
};

/** @internal */
export const TotalSupplySeriesResponse$inboundSchema: z.ZodType<
  TotalSupplySeriesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(z.array(z.number().int())),
});

/** @internal */
export type TotalSupplySeriesResponse$Outbound = {
  data: Array<Array<number>>;
};

/** @internal */
export const TotalSupplySeriesResponse$outboundSchema: z.ZodType<
  TotalSupplySeriesResponse$Outbound,
  z.ZodTypeDef,
  TotalSupplySeriesResponse
> = z.object({
  data: z.array(z.array(z.number().int())),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace TotalSupplySeriesResponse$ {
  /** @deprecated use `TotalSupplySeriesResponse$inboundSchema` instead. */
  export const inboundSchema = TotalSupplySeriesResponse$inboundSchema;
  /** @deprecated use `TotalSupplySeriesResponse$outboundSchema` instead. */
  export const outboundSchema = TotalSupplySeriesResponse$outboundSchema;
  /** @deprecated use `TotalSupplySeriesResponse$Outbound` instead. */
  export type Outbound = TotalSupplySeriesResponse$Outbound;
}

export function totalSupplySeriesResponseToJSON(
  totalSupplySeriesResponse: TotalSupplySeriesResponse,
): string {
  return JSON.stringify(
    TotalSupplySeriesResponse$outboundSchema.parse(totalSupplySeriesResponse),
  );
}

export function totalSupplySeriesResponseFromJSON(
  jsonString: string,
): SafeParseResult<TotalSupplySeriesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TotalSupplySeriesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TotalSupplySeriesResponse' from JSON`,
  );
}
